module.exports = __webpack_public_path__ + "static/media/19,055.80f9124d.jpg";